// extracted by mini-css-extract-plugin
module.exports = {"this":"styles_this__1igIO","secondary":"styles_secondary__2pJ5d"};